



























































































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";
import { pickObject } from "@root/utiles";
import TableHeaderSearch from "./children/TableHeaderSearch.vue";

const wt = namespace("wt");
@Component({
  components: { TableHeaderSearch }
})
@pagination("getData", {
  pageSize: 50
})
@SearchbarControl()
@loading()
@IsMore(true)
export default class ProductPickerDialog extends Vue {
  @wt.Action queryGtProductListSimple;
  @wt.Mutation addCacheDataList;
  @wt.Mutation updateCacheDataList; // 入参依赖productCode，注意
  @wt.Mutation clearCacheDataList;
  @wt.State cacheDataList;

  @Prop({ default: false }) visible: Boolean;
  @Prop({ default: () => {} }) initData: Array<any>; // 回显已经添加的商品

  private dataList = [];
  private hasSelectDataList = [];
  private selectDataList = [];

  private searchStr = null;
  private selectSearchStr = null;

  private activeName = "first";

  /**
   * 回显已选数据
   * 格式化已选数据。
   *  注意，入参的数据，可能有skuName，但是没有productName。
   *  但是skuName和productName一样，所以做相同处理。
   */
  @Watch("dialogVisible") async handleDialogVisible(val) {
    if (val) {
      const {
        resetDialogData,
        addObserveCacheDataList,
        updateCacheDataList
      } = this;
      resetDialogData();
      // 只过滤出spuCode，然后算到已添加当中
      const { initData, selectedComputed } = this;
      let formatInitData = initData.map(row => {
        const {
          productCode = "",
          skuCode = "",
          productName = "",
          skuName = ""
        } = row;
        return Object.assign(row, {
          productCode: productCode || skuCode,
          productName: productName || skuName
        });
      });
      this.$nextTick(async () => {
        await addObserveCacheDataList({
          dataList: formatInitData
        });
        if (selectedComputed.length > 0) {
          selectedComputed.forEach(row => {
            updateCacheDataList({ row, status: false });
          });
        }
        formatInitData.forEach(row => {
          updateCacheDataList({ row, status: true, isFlag: true });
        });
      });
    }
  }

  get dialogVisible() {
    return this.visible;
  }
  set dialogVisible(val) {
    this.$emit("update:visible");
  }
  get dataListComputed() {
    // dataList 和cacheDataList取交集
    const dataListCodes = this.dataList.map(el => el && el.productCode);
    const freshDataList = this.cacheDataList.filter(el => {
      return dataListCodes.includes(el && el.productCode);
    });
    return freshDataList;
  }
  get selectedComputed() {
    return this.cacheDataList.filter(el => el.hasSelected);
  }
  get fileterSelectedComputed() {
    const { selectSearchStr: search, selectedComputed } = this;
    return selectedComputed.filter(
      data =>
        !search ||
        (data.productName + data.productCode)
          .toLowerCase()
          .includes(search.toLowerCase())
    );
  }
  get selectedLength() {
    return this.selectedComputed.length;
  }
  handleSearch() {
    (this as any).currentPage = 1;
    this.getData();
  }
  @loadingCatch
  async getData() {
    const { pageSize, currentPage: pageNum } = this as any;
    const pageInput = {
      pageSize,
      pageNum
    };

    try {
      let { searchStr } = this;
      let conditionList = [
        {
          key: "status",
          value: "1",
          type: 0
        }
      ];
      if (searchStr) {
        conditionList.push({
          key: "productName,productCode",
          value: String(searchStr) as any,
          type: 4
        });
      }
      let condition = {
        orgCode: "default",
        conditionList,
        sortList: [
          {
            key: "createTime",
            type: 1
          }
        ]
      };
      const searchForm = {
        condition,
        pageInput
      };
      let { total, dataList: list } = await this.queryGtProductListSimple(
        searchForm
      );
      const { addObserveCacheDataList } = this;
      (this as any).total = total;
      // 增加 响应式属性 hasSelected
      this.dataList = list;
      addObserveCacheDataList({ dataList: list });
    } catch (err) {
      this.dataList = [];
      console.error(err);
      (this as any).total = 0;
    }
  }

  created() {
    this.getData();
    this.dialogVisible = false;
  }
  onClose() {
    this.dialogVisible = false;
    this.$emit("close");
  }
  tableCellClassName({ row, column, rowIndex, columnIndex }) {
    row.index = rowIndex;
    column.index = columnIndex;
  }
  formatData(dataList) {
    const objectPicks = [
      "productCode",
      "productName",
      "mediaLink",
      "mobileMediaLink",
      "salePrice",
      "productPrice",
      "orgCode",
      "orgName",
      "skus"
    ];
    return dataList.map(el => {
      const row = pickObject(el, objectPicks);
      if (!el.skus) {
        row["skus"] = [el];
        return row;
      }
      return row;
    });
  }
  handleSelectionChange(val) {
    this.selectDataList = val;
  }
  handleHasSelectChange(val) {
    this.hasSelectDataList = val;
  }
  handleConfirmSelect() {
    let { selectedComputed, formatData } = this;
    const newDataList = formatData(selectedComputed);
    console.log(newDataList, "newDataList");
    this.$emit("confirm", newDataList);
  }
  onSelectedData(row) {
    const { hasSelected } = row;
    this.updateCacheDataList({ row, status: !hasSelected });
  }
  onDeleteSelectedData(row) {
    // row.hasSelected = false;
    this.updateCacheDataList({ row, status: false });
  }
  changeListStatus(list = [], status = true) {
    // 复杂度 On^2
    const addProductCodes = list && list.map(({ productCode }) => productCode);
    list.forEach(row => {
      const { productCode } = row;
      if (addProductCodes.includes(productCode)) {
        this.updateCacheDataList({ row, status });
      }
    });
  }
  onAddBatch() {
    try {
      if (!this.selectDataList.length) {
        this.$message.warning("请选择商品后再点击批量添加！");
        return;
      }
      this.changeListStatus(this.selectDataList, true);
      this.refClearSelection("tableRef");
    } catch (error) {
      console.log(error);
    }
  }
  onDeleteBatch() {
    try {
      if (!this.hasSelectDataList.length) {
        this.$message.warning("请选择商品后再点击批量删除！");
        return;
      }
      this.changeListStatus(this.hasSelectDataList, false);
      this.refClearSelection("selectedTableRef");
    } catch (error) {
      console.log(error);
    }
  }
  handleSelectedData(row, column, cell, event) {
    // selected by spu 第一列 点击有效果
    if (column.index === 0) {
      (this.$refs.tableRef as any).toggleRowSelection(row);
    }
  }
  /**
   * 添加响应式属性，dataList为数据源
   * isFlag是添加isRowSeleceted的标志，默认设置为true，改过的都是false
   */
  addObserveCacheDataList({ dataList, isFlag = false }) {
    const { setObserveProp } = this;
    dataList = setObserveProp(dataList);
    dataList = setObserveProp(dataList, "isRowSelected", false);
    return this.addCacheDataList({ dataList });
  }
  /**
   * 添加响应式属性，hasSelected
   */
  setObserveProp(arrayList, setProp = "hasSelected", setPropValue = false) {
    if (!arrayList) return [];
    return (
      arrayList.map(row => {
        this.$set(row, setProp, setPropValue);
        return row;
      }) || []
    );
  }
  /**
   * refName: string | array
   */
  refClearSelection(refName) {
    try {
      this.$nextTick(() => {
        if (Array.isArray(refName)) {
          refName.forEach(ref => {
            (this.$refs[ref] as any) &&
              (this.$refs[ref] as any).clearSelection();
          });
        } else {
          (this.$refs[refName] as any) &&
            (this.$refs[refName] as any).clearSelection();
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
  beforeDestroy() {
    this.clearCacheDataList();
  }
  async resetDialogData() {
    this.activeName = "first";
    this.refClearSelection(["tableRef", "selectedTableRef"]);
    if (this.searchStr) {
      this.searchStr = null;
      await this.getData();
    }
    if (this.selectSearchStr) {
      this.selectSearchStr = null;
    }
  }
}
